import { Fragment } from 'react';
import { useCowbellTranslations } from '../../../../../../../../i18n/translations';
import { GridHeaderCell, TypographyUppercase } from '../CoverageGridCell';

export const CoverageHeader = ({
  coverageGroup,
}: {
  coverageGroup: string;
}) => {
  const { t } = useCowbellTranslations();

  return (
    <>
      <GridHeaderCell item md={4} sx={{ padding: '1rem' }}>
        <TypographyUppercase variant="caption" color="primary">
          {formatCoverageGroupName(coverageGroup)}
        </TypographyUppercase>
      </GridHeaderCell>
      {Array.from(new Array(2))
        .fill(null)
        .map((element, index) => (
          <Fragment key={index}>
            <GridHeaderCell item md={1}>
              {' '}
            </GridHeaderCell>

            <GridHeaderCell item md={1}>
              <TypographyUppercase variant="caption" color="primary">
                Limit
              </TypographyUppercase>
            </GridHeaderCell>

            <GridHeaderCell item md={1}>
              <TypographyUppercase variant="caption" color="primary">
                {t('retention')}
              </TypographyUppercase>
            </GridHeaderCell>

            <GridHeaderCell item md={1}>
              <TypographyUppercase variant="caption" color="primary">
                Retro
              </TypographyUppercase>
            </GridHeaderCell>
          </Fragment>
        ))}
    </>
  );
};

function formatCoverageGroupName(coverageGroup: string) {
  return coverageGroup.split('_').join(' ');
}
